import React, { useEffect } from "react";
import { Checkbox } from "antd";
import { FilterActions } from "..";

function TenantCheckBox({ tenant, _ApiTag, _extra, dispatch }) {
	useEffect(() => {
		dispatch({
			type: FilterActions.SetFlag,
			value: {
				_label: _ApiTag,
				_flagValue: { ..._extra, value: true }
			}
		});
	}, []);
	return (
		<Checkbox
			checked={tenant?.[_ApiTag] ? tenant?.[_ApiTag]?.value : false}
			onChange={e => {
				const {
					target: { checked }
				} = e;
				dispatch({
					type: FilterActions.SetFlag,
					value: {
						_label: _ApiTag,
						_flagValue: { ..._extra, value: checked }
					}
				});
			}}
		>
			Filter Client Shops
		</Checkbox>
	);
}

export default TenantCheckBox;
